import type { ReactNode } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/features/auth/useAuth'

/** Chrome shared by every admin screen: brand, current user, sign out. */
export function AppLayout({ children }: { children: ReactNode }) {
  const { user, signOut } = useAuth()

  return (
    <div className="app-shell">
      <header className="app-bar">
        <Link className="app-bar-brand" to="/">
          Speed Dating Portal
        </Link>
        <Link className="app-bar-link" to="/settings">
          Settings
        </Link>
        <div className="app-bar-spacer" />
        {/* The email is useful when an organiser has more than one login, but it
            is the first thing to go when the bar gets tight. */}
        <span className="muted hide-narrow">{user?.email}</span>
        <button className="btn btn-sm" type="button" onClick={() => void signOut()}>
          Sign out
        </button>
      </header>
      {children}
    </div>
  )
}

export function PageHeader({
  title,
  breadcrumb,
  actions,
}: {
  title: string
  breadcrumb?: ReactNode
  actions?: ReactNode
}) {
  return (
    <div className="page-header">
      <div className="page-title-group">
        {breadcrumb !== undefined && <div className="breadcrumb">{breadcrumb}</div>}
        <h1>{title}</h1>
      </div>
      {actions !== undefined && <div className="row">{actions}</div>}
    </div>
  )
}

export function ErrorBanner({ message }: { message: string }) {
  return (
    <p className="banner banner-danger" role="alert">
      {message}
    </p>
  )
}

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string
  description: string
  action?: ReactNode
}) {
  return (
    <div className="empty-state">
      <h2>{title}</h2>
      <p>{description}</p>
      {action}
    </div>
  )
}

export function Metric({ label, value }: { label: string; value: string | number }) {
  return (
    <div className="metric">
      <span className="metric-label">{label}</span>
      <span className="metric-value">{value}</span>
    </div>
  )
}
